export default __webpack_public_path__ + "static/button_menu_hakurei-1.0.0.png";